import { createContext, useContext } from 'react'
import { FALLBACK_NO_MAT_STYLE } from '../pages/PhotoStyler/TileDesignerConsts'
import { type TilesProviderContextValue } from 'components/TilesProvider/TilesProvider.types'

export const TilesProviderContext =
  createContext<TilesProviderContextValue | null>(null)
TilesProviderContext.displayName = 'TilesProviderContext'

export function useTiles(allowNull = false) {
  const context = useContext(TilesProviderContext)
  if (context === undefined && !allowNull) {
    throw new Error('useTiles must be used within a TilesProviderContext')
  }

  return (
    context ||
    ({
      tiles: [],
      nonCenterpieceTiles: [],
      fallbackStyle: FALLBACK_NO_MAT_STYLE,
    } as unknown as TilesProviderContextValue)
  )
}
